import {
  startOfDay,
  startOfYear,
  subDays,
  subMonths,
  subYears,
} from "date-fns";

export const sortChartByUnix = (data = []) => {
  return [...data].sort((a, b) => a.name - b.name);
};

export const filterChartByTimeframe = (data = [], period = "MAX") => {
  if (!data.length) return [];

  const sorted = sortChartByUnix(data);
  const lastTs = sorted[sorted.length - 1]?.name;
  if (!lastTs) return sorted;

  const lastDate = new Date(lastTs * 1000);
  let cutoff;

  switch (period.toLowerCase()) {
    case "1d":
      cutoff = startOfDay(lastDate);
      break;
    case "1w":
      cutoff = subDays(lastDate, 7);
      break;
    case "1m":
      cutoff = subMonths(lastDate, 1);
      break;
    case "ytd":
      cutoff = startOfYear(lastDate);
      break;
    case "1y":
      cutoff = subYears(lastDate, 1);
      break;
    default:
      return sorted;
  }

  const cutoffSec = Math.floor(cutoff.getTime() / 1000);
  return sorted.filter((d) => d.name >= cutoffSec);
};

export const normalizeChartData = (data = [], valueKey = "value") => {
  return data
    .map((item) => ({
      name: item.name,
      value: item[valueKey],
    }))
    .filter((d) => typeof d.value === "number");
};

export const getReturnSummary = (data = [], label) => {
  if (!data.length) {
    return {
      value: "$0.00",
      changePercentage: "0.00",
      direction: "up",
      changeText: label,
      chartData: [],
    };
  }

  const sorted = sortChartByUnix(data);
  const start = sorted[0].value;
  const end = sorted[sorted.length - 1].value;

  const gain = end - start;
  const percent = start ? (gain / start) * 100 : 0;

  return {
    value: gain.toLocaleString("en-US", { style: "currency", currency: "USD" }),
    changePercentage: percent.toFixed(2),
    direction: gain >= 0 ? "up" : "down",
    changeText: label,
    chartData: sorted.map((d) => ({
      name: new Date(d.name * 1000).toISOString(),
      $: d.value,
    })),
  };
};

export const getStrategyChartByKey = (data, key) => {
  if (!Array.isArray(data) || !key) return [];
  const lookupKey = key.toLowerCase();
  const found = data.find((item) => {
    return String(item.key).toLowerCase() === lookupKey;
  });
  return found?.value || [];
};
